import Typography from "@mui/material/Typography";
import React from "react";

interface Props {
  id?: string;
  title: string;
  children?: React.ReactNode;
}
export const CategoryAttributePlaceholder: React.FC<Props> = (props) => {
  return (
    <div
      id={props.id}
      style={{
        display: "flex",
        padding: "var(--6, 48px)",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 10,
        height: "100%",
        background: "#ffffff",
      }}
    >
      <Typography variant="h3">{props.title}</Typography>
      <Typography variant="body1">{props.children}</Typography>
    </div>
  );
};
